/** @format */

const template = `
<ng-form name="{{ctrl.name}}">
  <div class="row">
    <div ng-if="!ctrl.hideStartDate" class="col-lg-5">
      <label ng-class="{'required':ctrl.startDateRequired}" ng-hide="ctrl.hideLabels" translate
        >SIS_COMPONENTS.DATE.LOCAL_DATE_RANGE_EDITOR.START_DATE</label
      >
      <local-date-editor
        local-date="ctrl.ngModel.$viewValue.startDate"
        name="startDate"
        required="!ctrl.form[ctrl.name].$pristine && ctrl.startDateRequired"
        disabled="ctrl.startDateDisabled"
        on-change="ctrl.update()"
        data-cy="date-range-editor-startDate">
      </local-date-editor>
    </div>
    <div class="col-lg-1 date-range-gutter">
      <span class="hyphen">–</span>
    </div>
    <div class="col-lg-5">
      <label ng-class="{'required':ctrl.endDateRequired}" ng-hide="ctrl.hideLabels" translate
        >SIS_COMPONENTS.DATE.LOCAL_DATE_RANGE_EDITOR.END_DATE</label
      >
      <local-date-editor
        local-date="ctrl.ngModel.$viewValue.endDate"
        name="endDate"
        required="!ctrl.form[ctrl.name].$pristine && ctrl.endDateRequired"
        disabled="ctrl.endDateDisabled"
        min-date="ctrl.minEndDate"
        init-date="ctrl.initialEndDate"
        on-change="ctrl.update()"
        data-cy="date-range-editor-endDate">
      </local-date-editor>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <ul
        ng-if="!ctrl.hideErrors && ctrl.form[ctrl.name].$invalid && ctrl.showErrorList('startDate')"
        class="error-list"
        ng-messages="ctrl.form[ctrl.name].startDate.$error"
        ng-messages-multiple="true"
        role="alert">
        <li ng-message="required" translate>SIS_COMPONENTS.DATE.LOCAL_DATE_RANGE_EDITOR.START_DATE_IS_REQUIRED </li>
        <li ng-message="date, parse, pattern" translate>SIS_COMPONENTS.DATE.LOCAL_DATE_RANGE_EDITOR.START_DATE_MUST_MATCH_PATTERN </li>
      </ul>
      <ul
        ng-if="!ctrl.hideErrors && ctrl.form[ctrl.name].$invalid && ctrl.showErrorList('endDate')"
        class="error-list"
        ng-messages="ctrl.form[ctrl.name].endDate.$error"
        ng-messages-multiple="true"
        role="alert">
        <li ng-message="required" translate>SIS_COMPONENTS.DATE.LOCAL_DATE_RANGE_EDITOR.END_DATE_IS_REQUIRED </li>
        <li ng-message="date, parse, pattern" translate>SIS_COMPONENTS.DATE.LOCAL_DATE_RANGE_EDITOR.END_DATE_MUST_MATCH_PATTERN </li>
      </ul>
      <ul
        ng-if="!ctrl.hideErrors && ctrl.ngModel.$invalid"
        class="error-list"
        ng-messages="ctrl.ngModel.$error"
        ng-messages-multiple="true"
        role="alert">
        <li ng-message="startOrEndRequired" translate>SIS_COMPONENTS.DATE.LOCAL_DATE_RANGE_EDITOR.START_OR_END_DATE_IS_REQUIRED </li>
        <li ng-message="startBeforeEnd" translate>SIS_COMPONENTS.DATE.LOCAL_DATE_RANGE_EDITOR.START_DATE_MUST_BE_BEFORE_END_DATE </li>
      </ul>
    </div>
  </div>
</ng-form>
`;
export default template;
